export default __webpack_public_path__ + "static/media/hritik.3d24a09c.jpg";